package com.hyperether.goodjob.scenes.components

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Card
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import com.hyperether.goodjob.models.User
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.contact_information
import com.hyperether.goodjob.theme.SubtitleColor
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource


@Composable
fun UserContacts(
    isProfileView: Boolean = false,
    user: User?
) {
    Card(
        modifier = if (isProfileView) Modifier
            .fillMaxWidth()
            .padding(start = 16.toScaleDp(), end = 16.toScaleDp(), bottom = 10.toScaleDp()) else Modifier
            .fillMaxWidth()
            .padding(16.toScaleDp()),
        shape = RoundedCornerShape(8.toScaleDp()),
        elevation = if (isProfileView) 2.toScaleDp() else 4.toScaleDp()
    ) {
        Column(modifier = Modifier.padding(16.toScaleDp())) {
            Text(
                text = stringResource(Res.string.contact_information),
                fontWeight = FontWeight.Bold,
                fontSize = if (isProfileView) 16.toScaleSp() else 14.toScaleSp(),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            if (!user?.email.isNullOrBlank()) {
                Text(
                    text = user?.email.orEmpty(),
                    fontSize = 14.toScaleSp(),
                    color = if (isProfileView) SubtitleColor else Color.Gray,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            }
            if (!user?.phone.isNullOrBlank()) {
                Text(
                    text = user?.phone.orEmpty(),
                    color = if (isProfileView) SubtitleColor else Color.Gray,
                    fontSize = 14.toScaleSp(),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            }
            if (!user?.address.isNullOrBlank()) {
                Text(
                    text = user?.address.orEmpty(),
                    color = if (isProfileView) SubtitleColor else Color.Gray,
                    fontSize = 14.toScaleSp(),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            }
        }
    }
}
